import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Crestline tore off three layers of bad work from the last guys and built us a roof that finally feels like part of the house. Crew was on time every day, cleaned up better than my driveway has ever looked, and the warranty is in writing — not on a handshake.",
    name: "Margaret Holloway",
    location: "Westridge, Burnaby",
  },
  {
    quote:
      "We had a slow leak that two other companies couldn't trace. Crestline's inspector found it in 20 minutes, photographed everything, and gave us a fixed-price quote on the spot. The repair has held through two winters now. Honest people.",
    name: "David Chen",
    location: "Dunbar, Vancouver",
  },
  {
    quote:
      "After the November windstorm took half our shingles, Crestline had a crew tarping the roof the same evening. Full reroof was done in under three days. Calm, professional, and they never tried to upsell us once.",
    name: "Priya Sandhu",
    location: "Cloverdale, Surrey",
  },
  {
    quote:
      "I interviewed five roofers before choosing Crestline and I'm so glad I did. They walked me through every material option, showed me what the others were skipping, and the final invoice matched the quote to the dollar. Rare these days.",
    name: "James Whitford",
    location: "Edgemont, North Vancouver",
  },
  {
    quote:
      "Replaced a 35-year-old cedar shake roof on our heritage home. The crew respected the property, protected the garden beds with plywood every morning, and the new architectural shingles look better than I imagined. Worth every penny.",
    name: "Elena Marchetti",
    location: "Steveston, Richmond",
  },
  {
    quote:
      "Our strata had been getting quotes for two years that all felt slippery. Crestline showed up with drawings, references, and a clear scope. Sixteen units done in eleven days with zero complaints from owners. That's the bar now.",
    name: "Robert MacKenzie",
    location: "Burquitlam, Coquitlam",
  },
];

function Stars() {
  return (
    <div className="flex gap-1">
      {[0, 1, 2, 3, 4].map((i) => (
        <svg
          key={i}
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="text-[var(--crest-amber)]"
        >
          <path d="M12 2l2.9 6.9L22 10l-5.5 5L18 22l-6-3.5L6 22l1.5-7L2 10l7.1-1.1L12 2z" />
        </svg>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative bg-[var(--crest-charcoal)] py-20 md:py-28 overflow-hidden"
    >
      {/* Soft amber spotlight */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(217,119,6,0.10), transparent 70%)",
        }}
      />
      {/* Subtle slate accent */}
      <div
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 100%, rgba(30,41,59,0.6), transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="max-w-3xl mb-14">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[var(--crest-amber)]" />
            <span className="font-display uppercase tracking-[0.4em] text-xs font-semibold text-[var(--crest-amber)]">
              Homeowner Voices
            </span>
          </div>
          <h3
            data-testid="testimonials-heading"
            className="reveal font-display uppercase font-extrabold text-white leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)" }}
          >
            Hear It From
            <br />
            <span className="text-white/50">Your Neighbours.</span>
          </h3>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="reveal relative bg-[#161616] border border-white/10 p-7 md:p-8 flex flex-col card-lift"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <Quote
                size={22}
                strokeWidth={1.5}
                className="text-[var(--crest-amber)] mb-5"
              />
              <p
                data-testid={`testimonial-quote-${i}`}
                className="font-body italic text-sm md:text-[15px] leading-relaxed text-white/80 flex-1"
              >
                &ldquo;{t.quote}&rdquo;
              </p>

              <div className="mt-7 pt-5 border-t border-white/10 flex items-end justify-between gap-3">
                <div>
                  <div
                    data-testid={`testimonial-name-${i}`}
                    className="font-display uppercase font-bold text-sm tracking-[0.18em] text-white leading-tight"
                  >
                    {t.name}
                  </div>
                  <div className="font-body text-[10px] uppercase tracking-[0.25em] text-white/45 mt-1.5">
                    {t.location}
                  </div>
                </div>
                <Stars />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
